import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid, TextField, Typography } from "@mui/material";
import { API } from "aws-amplify";
import { useUser } from "../contexts/useUser";

const InviteDialog = (props: any) => {
  const { open, setOpen } = props;
  const [emailed, setEmailed] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const {user} = useUser();

  const sendEmail = async () => {
    // check that the emails are a comma or newline separated list on valid email addresses
    const emailList = email.split(/[\s,]+/);
    let validEmails = true;
    emailList.forEach((email) => {
      // regular expression for valid email addresses
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        validEmails = false;
      }
    });

    if (!validEmails || emailList.length === 0) {
      setEmailError(
        "Please enter a comma separated list of valid email addresses."
      );
      return;
    }

    const params = {
      email: email,
      projectId: user?.project?.id,
      projectName: user?.project?.name,
      inviterName: user?.displayName,
      inviterEmail: user?.email,
    };

    try {
      await API.post("eventapi", "/invitation", { body: params });
        setEmailed(true);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="invite-dialog"
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle id="invite-dialog">
        Invite users to project
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body1">
             Send an invitation to colleagues you want to
              also have access to manage LLM features for this project. Enter a comma separated list of email addresses and click send.
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ m: 2 }}>
            <TextField
              variant="outlined"
              onChange={(e) => {
                setEmailError("");
                setEmail(e.target.value);
              }}
              label="Email invite to"
              fullWidth
              multiline
              rows={4}
              error={emailError !== ""}
              helperText={emailError}
            />
          </Grid>
          <Grid item xs={12}>
            {emailed ? (
              <span style={{ color: "green" }}>
                &nbsp;Emailed invitation(s).
              </span>
            ) : null}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            sendEmail();
          }}
        >
          Email Invitation(s)
        </Button>{" "}
        <Button
          variant="outlined"
          onClick={() => {
            setOpen(false);
          }}
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default InviteDialog;
